import { memo, ReactNode } from 'react';

import Editor from './Editor';
import {
  TAbstractEntity,
  TAbstractNewEntity,
  TEditorConfig,
} from './Editor/interface';
import { TContext } from './context';
import useOpenEditor from './useOpenEditor';

export function EditorWrapper<
  TContainer extends TAbstractEntity | null,
  TEntity extends TAbstractEntity,
  TNewEntity extends TAbstractNewEntity,
>({
  children,
  config,
  ctx,
}: {
  children: ReactNode;
  config: TEditorConfig<TContainer, TEntity, TNewEntity>;
  ctx: TContext<TEntity>;
}) {
  const { entity, mode, ctxValue, container, onResult } = useOpenEditor<
    TContainer,
    TEntity,
    TNewEntity
  >(config);

  return (
    <>
      <Editor<TContainer, TEntity, TNewEntity>
        entity={entity}
        container={container}
        mode={mode}
        onResult={onResult}
        config={config}
      />
      <ctx.Provider value={ctxValue}>{children}</ctx.Provider>
    </>
  );
}

export default memo(EditorWrapper) as typeof EditorWrapper;
